export const Footer = () => {
  return (
    <div>
      <h3 className="footer-text">Made with &#x2764;&#xFE0F; in Florida</h3>
    </div>
  );
};
